import React, { useState } from 'react'
import Inputwithlable from '../../components/common/inputwithlable'
import TableHeading from '../../components/common/TableHeading'
import { handleFormInput } from '../../../utills/formutilities'
import { changePasswordAdmin } from '../../../services/api-services'
import { toastEmitter } from '../../../utills/utilities'
import { API_RESPONSE } from '../../../utills/app-constant'
import { useSelector } from 'react-redux'
import { checkValidation, ErrorMessage, ErrorMsg } from '../../../utills/error-message-constant'
import { passwordRegex } from '../../../utills/form-regex'

const AdminChangePassword = () => {
  const { value } = useSelector((state) => state?.loggedUser);
  const [formError, setFormError] = useState();
  const [payload, setpayload] = useState({
    id: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "oldPassword") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Password,
        passwordRegex,
        formError,
        setFormError
      );
    }
    if (name === "newPassword") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Password,
        passwordRegex,
        formError,
        setFormError
      );
    }
    if (name === "confirmPassword") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.ConfirmPassword,
        passwordRegex,
        formError,
        setFormError
      );
    }
    setpayload(handleFormInput(e, payload))
  }

  const handleChangePassword = async () => {
    if (payload?.newPassword !== payload?.confirmPassword) {
      toastEmitter("error", "New Password And Confirm Password Should be Same");
      return;
    }
    let changePasswordPayload = {
      id: value?.id,
      oldPassword: payload?.oldPassword,
      newPassword: payload?.newPassword
    }
    try {
      const response = await changePasswordAdmin(changePasswordPayload);
      if (response?.data?.responseCode !== 200) {
        toastEmitter("error", response?.data?.message);
      }

      if (response.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    }
  }

  return (
    <div>
      <div>
        <TableHeading firstData="Change Password" />
      </div>
      <div className="admin_profile m-3">
        <div className="admin_profile_content">
          <div className="row ">
            <div className="col-md-12">
              <Inputwithlable
                placeHolder="Enter the current password"
                name="oldPassword"
                type="text"
                labelName="Current Password"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                value={payload?.oldPassword}
                handleChange={handleChange}
                error={formError?.passwordStatus}
              />
            </div>
            <div className="mt-2 ms-2"><ErrorMsg error={formError?.oldPassword} /></div>
            <div className="col-md-12">
              <Inputwithlable
                placeHolder="Enter the new password"
                name="newPassword"
                type="text"
                labelName="New Password"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                value={payload?.newPassword}
                handleChange={handleChange}
              />
            </div>
            <div className="mt-2 ms-2"><ErrorMsg error={formError?.newPassword} /></div>
            <div className="col-md-12">
              <Inputwithlable
                placeHolder="Enter the confirm password"
                name="confirmPassword"
                type="text"
                labelName="Confirm New Password"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                value={payload?.confirmPassword}
                handleChange={handleChange}
                error={formError?.confirmPasswordStatus}
              />
            </div>
            <div className="mt-2 ms-2"><ErrorMsg error={formError?.confirmPassword} /></div>
          </div>
          <div className='d-flex justify-content-center align-items-center'>
            <button className="changespassword mt-4 mb-0" onClick={handleChangePassword}>Change Password</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminChangePassword
